import React, { useState, ChangeEvent, useEffect } from "react";
import Popup from "../components/Popup";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useNavigate } from "react-router-dom";
import { deleteHealthCondition, fetchUserData } from "../store/UserSlice";
import PopupContentEdit from "../components/Forms/HealthConditionEdit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteConfirmation from "../components/ConfirmBox";
import { IHealthCondition } from "../interfaces/HealthCondition";

export default function Dashboard() {
  
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpenFoeEdit, setIsPopupOpenFoeEdit] = useState(false);
  const [changeText, setChangeText] = useState(true);
  const [deleteItemId, setDeleteItemId] = useState<string | null>(null);

  // Assuming your RootState has a 'user' slice
  //setIsPopupOpen(false);
  const [editedHealthConditionId, setEditedHealthConditionId] = useState<
    string | null
  >(null);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const openEditPopup = (healthConditionId: string) => {
    
    setEditedHealthConditionId(healthConditionId);
    setIsPopupOpenFoeEdit(true);
  };
  


  const storedData = localStorage.getItem("loginData");
  let accessToken = "";

  if (storedData !== null) {
    try {
      const parsedData = JSON.parse(storedData);
      accessToken = parsedData?.accessToken;
    } catch (error) {
      console.error("Error parsing stored data:", error);
    }
  }
 

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setChangeText(e.target.value === "");
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const closePopups = () => {
    setIsPopupOpenFoeEdit(false);
  };
  const dispatch = useDispatch<any>();

  const { data, loading, error } = useSelector(
    (state: RootState) => state.user
  );

  useEffect(() => {
    dispatch(fetchUserData());
  }, [dispatch]);

  if (!data) {
    return <div>No data available</div>;
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        {loading && (
          <div
            className="border-t-4 border-solid h-16 w-16 border-b-4 border-r-4 border-l-4 rounded-full animate-spin"
            style={{ borderColor: "#B4804A" }}
          />
        )}
      </div>
    );
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }
  const handleDelete = (healthConditionId: string) => {
    // Dispatch the delete action
    dispatch(deleteHealthCondition(healthConditionId)).then(() => {
      dispatch(fetchUserData()).then(() => {
        toast.success("Sucessfully Deleted");
        setDeleteItemId(null);
      });
    });
  };
  const handleCancel = () => {
    setDeleteItemId(null);
  };

  const parsedData = typeof data === "string" ? JSON.parse(data) : data;

  return (
    <>
      <h2 className="py-1 pb-4 text-2xl font-gilroy font-semibold text-[#2b404b]">
        Health Conditions
      </h2>
      <div className="bg-white h-[calc(100vh-190px)] overflow-y-scroll md:overflow-hidden rounded-md">
        <div className="flex flex-col md:flex-row p-6 mb-1">
          <form className="flex items-start w-80 md:w-1/2">
            <div className="relative">
              <input
                type="text"
                placeholder=""
                onChange={handleInputChange}
                className="border rounded-md py-2 w-60 md:w-96 px-4 focus:outline-none placeholder-[#B0BEC5] bg-[#F5F7F8]"
              />
              {changeText && (
                <div className="absolute inset-y-0 left-0 pt-1 pl-4 flex items-center pointer-events-none">
                  <img
                    src="./images/Vector.png"
                    className="mx-auto mb-2 "
                    alt="search"
                  />{" "}
                  <span className="pl-1 leading-3 text-[#B0BEC5]">Search</span>
                </div>
              )}
            </div>
          </form>
          <Link
            to=""
            className="bg-[#B4804A] flex ml-0 md:ml-auto mt-4 md:mt-0 py-2 px-4 justify-center text-center items-center rounded-lg leading-8 font-gilroy font-bold  text-white w-60"
            onClick={() => openPopup()}
          >
            <img
              src="./images/plus.png"
              className="pr-2 object-contain	"
              alt="btn"
            />
            Add New Condition
          </Link>
        </div>

        <div className="flex flex-row flex-wrap p-4 overflow-y-scroll max-h-full scrollbar-hide pb-20">
          {parsedData.healthConditions &&
            parsedData.healthConditions.map(
              (healthCondition: IHealthCondition) => (
                <div
                  className="basis-1/2 md:basis-1/5 px-2 md:px-4 mb-8 "
                  key={healthCondition.id}
                  id={healthCondition.id}
                >
                  <div className="shadow-[0_0px_14px_rgb(0,0,0,0.1)] shrink-0 flex h-60 flex-col py-1 px-2 md:px-4 text-center rounded-xl group border-white  border hover:border-[#B4804A]">
                    <div className="float-right text-right">
                      <button
                        className="opacity-0 group-hover:opacity-100"
                        onClick={() => openEditPopup(healthCondition.id)}
                      >
                        <img
                          src="./images/Edit.png"
                          className="pt-2 float-right"
                          alt="edit"
                        />
                      </button>
                      <button
                        className="opacity-0 group-hover:opacity-100"
                        onClick={() => setDeleteItemId(healthCondition.id)}
                      >
                        <img
                          src="./images/delete.png"
                          className="pt-2 px-2 pr-4"
                          alt="delete"
                        />
                      </button>
                      {deleteItemId === healthCondition.id && (
                        <DeleteConfirmation
                          onConfirm={() => handleDelete(healthCondition.id)}
                          onCancel={handleCancel}
                          message={healthCondition.name}
                        />
                      )}
                    </div>
                    <img
                      src={healthCondition.icon}
                      className="mx-auto mb-3 h-32 object-contain"
                      alt={healthCondition.name}
                    />
                    <h4 className="mb-1 font-semibold	text-[#263238] text-base	font-gilroy capitalize">
                      {healthCondition.name}
                    </h4>
                  </div>
                </div>
              )
            )}
        </div>
        {isPopupOpen && <Popup closePopup={closePopup} />}

        {isPopupOpenFoeEdit && editedHealthConditionId && (
          // Render Popup with healthConditionId when editedHealthConditionId is not null
          <PopupContentEdit
            closePopups={closePopups}
            existingHealthConditionId={editedHealthConditionId}
          />
        )}
      </div>
    </>
  );
}
